module.exports = __webpack_public_path__ + "static/media/lock.386c2897.jpeg";